// AuthContainer.tsx
import React from 'react';
import { Box, Card, Container } from '@mui/material';
import { useAuthStore } from '../../store/useAuthStore3';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import OnboardingForm from './OnboardingForm';
import WaitForConfirmation from './WaitForConfirmation';
import ForgotPasswordForm from './ForgotPasswordForm';
import { ForgotPasswordSuccess } from './ForgotPasswordSuccess';

export const AuthContainer: React.FC = () => {
  const { authState } = useAuthStore();

  // Функция возвращает нужную форму в зависимости от состояния машины
  const renderForm = () => {
    switch (authState) {
      case 'LOGIN':
        return <LoginForm />;

      case 'NOT_REGISTERED':
        return <SignUpForm />;

      case 'REGISTERED':
        // Когда пользователь зарегистрирован, но еще не заполнил доп. данные
        return <OnboardingForm />;

      case 'WAIT_FOR_EMAIL_CONFIRMATION':
        return <WaitForConfirmation />;

      case 'FORGOT_PASSWORD':
        return <ForgotPasswordForm />;

      case 'FORGOT_PASSWORD_SUCCESS':
        return <ForgotPasswordSuccess />;
      
      case 'AUTHORIZED':
        return null;

      case 'REGISTERED_AND_SET_UP':
        return null;

      default:
        // Фолбек на случай непредвиденного стейта
        return <LoginForm />;
    }
  };

  return (
    // Красивая центрированная оболочка для всех наших форм
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card variant="outlined" sx={{ p: 4, borderRadius: '12px', boxShadow: 3 }}>
        {renderForm()}
      </Card>
    </Container>
  );
};

export default AuthContainer;